// Generated by scripts/generate-content-catalog.mjs. Do not edit manually.

export const blogCatalog = [
  {
    "slug": "shipping-tax-mixed-cart",
    "img": "/assets/cover-shipping-tax-mixed-cart.jpg",
    "tag": "eCommerce",
    "title": "Shipping Tax on Mixed Carts: Taxable and Exempt Items",
    "description": "Handle shipping tax on mixed carts with a New York allocation example, free-shipping checks, discount scenarios, refunds, and a practical checkout test plan.",
    "publishedOn": "2026-09-18",
    "time": "5 min read"
  },
  {
    "slug": "zero-sales-tax-return",
    "img": "/assets/cover-zero-sales-tax-return.jpg",
    "tag": "Compliance",
    "title": "Zero Sales Tax Returns: When and How to File",
    "description": "Learn why an active sales tax account may still need a return with no sales, and check exempt sales, marketplace receipts, use tax, and account closure.",
    "publishedOn": "2026-09-18",
    "time": "5 min read"
  },
  {
    "slug": "ioss-for-us-sellers",
    "img": "/assets/cover-ioss-for-us-sellers.jpg",
    "tag": "eCommerce",
    "title": "IOSS for US Sellers: EU VAT and Small-Parcel Duties",
    "description": "Understand IOSS for US sellers: eligible consignments, EU intermediaries, marketplace orders, monthly VAT reporting, and the separate July 2026 customs duty.",
    "publishedOn": "2026-09-18",
    "time": "5 min read"
  },
  {
    "slug": "calculate-sales-tax-from-total",
    "img": "/assets/cover-calculate-sales-tax-from-total.jpg",
    "tag": "Tax Tips",
    "title": "How to Calculate Sales Tax from a Total Price",
    "description": "Separate sales tax from a tax-inclusive total with a simple formula, worked examples, and checks for mixed baskets, fees, discounts, and rounding.",
    "publishedOn": "2026-09-06",
    "time": "5 min read"
  },
  {
    "slug": "sales-tax-bad-debt-unpaid-invoices",
    "img": "/assets/cover-sales-tax-bad-debt-unpaid-invoices.jpg",
    "tag": "Compliance",
    "title": "Sales Tax on Unpaid Invoices: Bad Debt Relief Explained",
    "description": "Understand why an unpaid invoice does not automatically reverse sales tax, and what to check before claiming state bad debt relief.",
    "publishedOn": "2026-09-06",
    "time": "5 min read"
  },
  {
    "slug": "sales-tax-rounding-differences",
    "img": "/assets/cover-sales-tax-rounding-differences.jpg",
    "tag": "Tax Tips",
    "title": "Sales Tax Rounding: Why Checkout Totals Differ by a Cent",
    "description": "Trace sales tax rounding differences through line items, invoice totals, rate components, discounts, and refunds with a clear worked example.",
    "publishedOn": "2026-09-06",
    "time": "5 min read"
  },
  {
    "slug": "remote-sellers-multi-state-sales-tax",
    "img": "/assets/cover-remote-sellers-multi-state-sales-tax.jpg",
    "tag": "Compliance",
    "title": "Multi-State Sales Tax for Remote Sellers: 2026 Guide",
    "description": "A practical 2026 workflow for finding nexus, registering in the right states, collecting accurately, and keeping multi-state filings under control.",
    "publishedOn": "2026-08-08",
    "time": "6 min read"
  },
  {
    "slug": "economic-nexus-thresholds",
    "img": "/assets/cover-economic-nexus-thresholds.jpg",
    "tag": "Compliance",
    "title": "Economic Nexus Thresholds in 2026: What Counts?",
    "description": "Learn how sales bases, measurement periods, marketplace orders, and changing transaction tests affect economic nexus monitoring in 2026.",
    "publishedOn": "2026-08-08",
    "time": "5 min read"
  },
  {
    "slug": "common-sales-tax-mistakes",
    "img": "/assets/cover-common-sales-tax-mistakes.jpg",
    "tag": "Tax Tips",
    "title": "7 Sales Tax Mistakes Online Sellers Should Avoid",
    "description": "Seven preventable errors that lead to incorrect checkout tax, late returns, weak exemption records, and avoidable audit exposure.",
    "publishedOn": "2026-08-08",
    "time": "6 min read"
  },
  {
    "slug": "marketplace-facilitator-laws",
    "img": "/assets/cover-marketplace-facilitator-laws.jpg",
    "tag": "eCommerce",
    "title": "Marketplace Facilitator Laws: Seller Checklist for 2026",
    "description": "Understand what marketplaces usually collect, what sellers still own, and how to reconcile facilitated and direct sales without double reporting.",
    "publishedOn": "2026-08-08",
    "time": "5 min read"
  },
  {
    "slug": "sales-tax-holidays",
    "img": "/assets/cover-sales-tax-holidays.jpg",
    "tag": "Updates",
    "title": "2026 Sales Tax Holidays: Seller Preparation Guide",
    "description": "Prepare products, price caps, local rules, discounts, returns, and checkout timing for the official 2026 state sales tax holiday calendar.",
    "publishedOn": "2026-08-08",
    "time": "5 min read"
  },
  {
    "slug": "saas-taxability-guide",
    "img": "/assets/cover-saas-taxability-guide.jpg",
    "tag": "Compliance",
    "title": "Is SaaS Taxable? 2026 State Sales Tax Guide",
    "description": "A practical way to analyze SaaS taxability using product facts, customer location, state classifications, bundled services, and current authority.",
    "publishedOn": "2026-08-08",
    "time": "5 min read"
  },
  {
    "slug": "cross-border-ecommerce-tax",
    "img": "/assets/cover-cross-border-ecommerce-tax.jpg",
    "tag": "eCommerce",
    "title": "Cross-Border eCommerce Tax: VAT, GST, Duties & Platforms",
    "description": "Build a reliable cross-border checkout process for VAT, GST, customs duties, low-value imports, customer evidence, and marketplace responsibilities.",
    "publishedOn": "2026-08-08",
    "time": "5 min read"
  },
  {
    "slug": "sales-tax-permit-registration",
    "img": "/assets/cover-sales-tax-permit-registration.jpg",
    "tag": "Compliance",
    "title": "How to Register for a Sales Tax Permit: 2026 Guide",
    "description": "A step-by-step sales tax registration workflow covering nexus confirmation, application data, collection dates, account setup, and post-registration controls.",
    "publishedOn": "2026-08-08",
    "time": "4 min read"
  },
  {
    "slug": "origin-vs-destination-sales-tax-sourcing",
    "img": "/assets/cover-origin-vs-destination-sales-tax-sourcing.jpg",
    "tag": "Tax Tips",
    "title": "Origin vs Destination Sales Tax: Sourcing Guide",
    "description": "Learn how sales tax sourcing identifies the jurisdiction and rate for shipped goods, pickup orders, services, remote sales, and multi-location customers.",
    "publishedOn": "2026-08-08",
    "time": "4 min read"
  },
  {
    "slug": "is-shipping-taxable-sales-tax",
    "img": "/assets/cover-is-shipping-taxable-sales-tax.jpg",
    "tag": "eCommerce",
    "title": "Is Shipping Taxable? Sales Tax Guide for Sellers",
    "description": "Understand how states can treat shipping, delivery, freight, postage, handling, bundled charges, free shipping, and returns differently.",
    "publishedOn": "2026-08-08",
    "time": "4 min read"
  },
  {
    "slug": "digital-products-sales-tax-guide",
    "img": "/assets/cover-digital-products-sales-tax-guide.jpg",
    "tag": "Compliance",
    "title": "Are Digital Products Taxable? 2026 Sales Tax Guide",
    "description": "A practical framework for classifying downloads, streaming, digital goods, online content, software, subscriptions, and automated services.",
    "publishedOn": "2026-08-08",
    "time": "4 min read"
  },
  {
    "slug": "sales-tax-audit-checklist",
    "img": "/assets/cover-sales-tax-audit-checklist.jpg",
    "tag": "Tax Tips",
    "title": "Sales Tax Audit Checklist: How to Prepare",
    "description": "Prepare for a sales tax audit with a controlled data request process, transaction reconciliations, exemption evidence, system documentation, and issue tracking.",
    "publishedOn": "2026-08-08",
    "time": "4 min read"
  },
  {
    "slug": "how-to-file-sales-tax-return",
    "img": "/assets/cover-how-to-file-sales-tax-return.jpg",
    "tag": "Compliance",
    "title": "How to File a Sales Tax Return: Step-by-Step Guide",
    "description": "A repeatable filing workflow for reconciling gross sales, deductions, marketplace activity, taxable sales, jurisdiction schedules, payments, and amendments.",
    "publishedOn": "2026-08-08",
    "time": "4 min read"
  },
  {
    "slug": "sales-tax-discounts-coupons-gift-cards",
    "img": "/assets/cover-sales-tax-discounts-coupons-gift-cards.jpg",
    "tag": "Tax Tips",
    "title": "Sales Tax on Discounts, Coupons & Gift Cards",
    "description": "Learn how store discounts, manufacturer coupons, third-party vouchers, gift cards, loyalty rewards, bundles, and refunds can change the taxable amount.",
    "publishedOn": "2026-08-08",
    "time": "4 min read"
  },
  {
    "slug": "dropshipping-sales-tax-guide",
    "img": "/assets/cover-dropshipping-sales-tax-guide.jpg",
    "tag": "eCommerce",
    "title": "Dropshipping Sales Tax Guide for Online Sellers",
    "description": "Map the retailer, supplier, customer, resale documentation, nexus, sourcing, marketplace, and drop-shipment rules before configuring tax.",
    "publishedOn": "2026-08-08",
    "time": "4 min read"
  },
  {
    "slug": "sales-tax-vs-use-tax",
    "img": "/assets/cover-sales-tax-vs-use-tax.jpg",
    "tag": "Tax Tips",
    "title": "Sales Tax vs Use Tax: What Businesses Need to Know",
    "description": "Understand consumer use tax, seller-collected use tax, untaxed purchases, inventory withdrawals, cross-jurisdiction rate differences, and reporting controls.",
    "publishedOn": "2026-08-08",
    "time": "4 min read"
  },
  {
    "slug": "vat-vs-gst-vs-sales-tax",
    "img": "/assets/cover-vat-vs-gst-vs-sales-tax.jpg",
    "tag": "eCommerce",
    "title": "VAT vs GST vs Sales Tax: Key Differences Explained",
    "description": "Compare collection stages, input credits, registration, invoices, B2B treatment, imports, platforms, rates, and reporting across major consumption-tax systems.",
    "publishedOn": "2026-08-08",
    "time": "4 min read"
  },
  {
    "slug": "resale-certificates-online-sellers",
    "img": "/assets/cover-resale-certificates-online-sellers.jpg",
    "tag": "Compliance",
    "title": "Resale Certificates for Online Sellers: A Practical Guide",
    "description": "Learn when resale certificates apply, which form to collect, how sellers should validate them, and how to keep exemption records ready for audit.",
    "publishedOn": "2026-08-16",
    "time": "8 min read"
  },
  {
    "slug": "sales-tax-returns-refunds-exchanges",
    "img": "/assets/cover-sales-tax-returns-refunds-exchanges.jpg",
    "tag": "Tax Tips",
    "title": "Sales Tax on Returns, Refunds & Exchanges",
    "description": "A seller workflow for refunding tax, handling partial returns and restocking charges, correcting filed periods, and reconciling exchanges across channels.",
    "publishedOn": "2026-08-16",
    "time": "8 min read"
  },
  {
    "slug": "sales-tax-product-bundles-gift-baskets",
    "img": "/assets/cover-sales-tax-product-bundles-gift-baskets.jpg",
    "tag": "eCommerce",
    "title": "Sales Tax on Product Bundles & Gift Baskets",
    "description": "Learn how mixed taxable and exempt items, allocation records, packaging, discounts, shipping, and subscriptions affect tax on product bundles.",
    "publishedOn": "2026-08-16",
    "time": "7 min read"
  },
  {
    "slug": "close-sales-tax-permit-account",
    "img": "/assets/cover-close-sales-tax-permit-account.jpg",
    "tag": "Compliance",
    "title": "How to Close a Sales Tax Permit or Account",
    "description": "A controlled offboarding process for confirming nexus has ended, filing final returns, closing state accounts, preserving records, and preventing future notices.",
    "publishedOn": "2026-08-16",
    "time": "8 min read"
  },
  {
    "slug": "billing-vs-shipping-address-sales-tax",
    "img": "/assets/cover-billing-vs-shipping-address-sales-tax.jpg",
    "tag": "Tax Tips",
    "title": "Billing vs Shipping Address: Which Sets Sales Tax?",
    "description": "Why the shipping address usually matters more than the billing address for sales tax, where pickup and digital orders differ, and how sellers can prevent address-based rate errors.",
    "publishedOn": "2026-08-23",
    "time": "8 min read"
  },
  {
    "slug": "states-with-no-sales-tax",
    "img": "/assets/cover-states-with-no-sales-tax.jpg",
    "tag": "Tax Tips",
    "title": "Which States Have No Sales Tax in 2026?",
    "description": "A practical look at Alaska, Delaware, Montana, New Hampshire, and Oregon—and why “no state sales tax” does not mean every transaction is tax-free.",
    "publishedOn": "2026-08-23",
    "time": "8 min read"
  },
  {
    "slug": "sales-tax-on-services",
    "img": "/assets/cover-sales-tax-on-services.jpg",
    "tag": "Tax Tips",
    "title": "Are Services Taxable? A Sales Tax Guide for Businesses",
    "description": "A practical method for deciding whether consulting, repair, installation, digital, maintenance, and bundled services are subject to sales tax.",
    "publishedOn": "2026-08-28",
    "time": "6 min read"
  },
  {
    "slug": "sales-tax-rentals-leases",
    "img": "/assets/cover-sales-tax-rentals-leases.jpg",
    "tag": "Compliance",
    "title": "Sales Tax on Rentals and Leases: What Businesses Should Track",
    "description": "How purchase tax, recurring rental charges, equipment location, mandatory fees, subleases, and buyouts affect sales tax on leased property.",
    "publishedOn": "2026-08-28",
    "time": "5 min read"
  },
  {
    "slug": "sales-tax-trade-ins-rebates",
    "img": "/assets/cover-sales-tax-trade-ins-rebates.jpg",
    "tag": "Tax Tips",
    "title": "Sales Tax on Trade-Ins, Rebates, and Dealer Discounts",
    "description": "Why trade-in credits, manufacturer rebates, dealer discounts, down payments, and incentives can produce different taxable amounts by state.",
    "publishedOn": "2026-08-28",
    "time": "5 min read"
  }
] as const

export const guideCatalog = [
  {
    "slug": "us-sales-tax-guide",
    "filter": "United States",
    "tag": "United States",
    "title": "US Sales Tax Guide for Online Sellers (2026)",
    "description": "A practical 2026 guide to sales tax nexus, registration, sourcing, product taxability, filing, and marketplace sales in the United States.",
    "publishedOn": "2026-08-08",
    "time": "6 min read"
  },
  {
    "slug": "canada-hst-gst-pst",
    "filter": "Canada",
    "tag": "Canada",
    "title": "Canada GST, HST & PST Guide for Businesses (2026)",
    "description": "Understand Canada’s GST/HST registration threshold, provincial sales taxes, place-of-supply rules, input tax credits, and digital-economy obligations.",
    "publishedOn": "2026-08-08",
    "time": "5 min read"
  },
  {
    "slug": "eu-vat-online-sellers",
    "filter": "Europe",
    "tag": "Europe",
    "title": "EU VAT for Online Sellers: OSS, IOSS & 2026 Rules",
    "description": "A current guide to EU VAT rates, the €10,000 cross-border threshold, OSS, IOSS, marketplaces, VIES, and the July 2026 low-value import duty change.",
    "publishedOn": "2026-08-08",
    "time": "6 min read"
  },
  {
    "slug": "sales-tax-nexus-state-by-state",
    "filter": "United States",
    "tag": "United States",
    "title": "Economic Nexus by State: 2026 Sales Tax Guide",
    "description": "Learn how state economic nexus thresholds work, which sales count, why transaction thresholds are disappearing, and how to build a defensible monitoring process.",
    "publishedOn": "2026-08-08",
    "time": "5 min read"
  },
  {
    "slug": "marketplace-facilitator-rules",
    "filter": "eCommerce",
    "tag": "eCommerce",
    "title": "Marketplace Facilitator Sales Tax Guide (2026)",
    "description": "Understand when marketplaces collect and remit sales tax, what sellers still own, how marketplace sales affect nexus, and how to reconcile every channel.",
    "publishedOn": "2026-08-08",
    "time": "5 min read"
  },
  {
    "slug": "australia-gst-guide",
    "filter": "Asia-Pacific",
    "tag": "Asia-Pacific",
    "title": "Australia GST Guide for Online & Overseas Sellers (2026)",
    "description": "A practical guide to Australia’s 10% GST, A$75,000 registration threshold, digital products, low-value imported goods, platforms, BAS, and records.",
    "publishedOn": "2026-08-08",
    "time": "5 min read"
  },
  {
    "slug": "tax-exemptions-certificates",
    "filter": "United States",
    "tag": "Documentation",
    "title": "Sales Tax Exemption & Resale Certificates Guide (2026)",
    "description": "Learn how to collect, validate, store, renew, and audit resale and exemption certificates across US sales tax jurisdictions.",
    "publishedOn": "2026-08-08",
    "time": "5 min read"
  },
  {
    "slug": "sales-tax-nexus-determination",
    "filter": "United States",
    "tag": "Nexus Assessment",
    "title": "Sales Tax Nexus Determination: A Step-by-Step Guide",
    "description": "Determine sales tax nexus using physical presence, state revenue definitions, marketplace records, threshold timing, and a documented registration decision.",
    "publishedOn": "2026-09-18",
    "time": "5 min read"
  },
  {
    "slug": "saas-sales-tax-customer-location",
    "filter": "United States",
    "tag": "SaaS Sourcing",
    "title": "SaaS Sales Tax Sourcing: Where Is Software Used?",
    "description": "Determine SaaS customer location with user evidence, state-specific sourcing rules, multistate allocation, billing controls, and a worked subscription example.",
    "publishedOn": "2026-09-18",
    "time": "5 min read"
  },
  {
    "slug": "australia-gst-low-value-imported-goods",
    "filter": "Asia-Pacific",
    "tag": "Australia Imports",
    "title": "Australia GST on Low-Value Imported Goods",
    "description": "Plan Australian GST for overseas goods sales: the A$1,000 goods test, A$75,000 turnover threshold, marketplace responsibility, shipping data, and refunds.",
    "publishedOn": "2026-09-18",
    "time": "5 min read"
  },
  {
    "slug": "ecommerce-checkout-sales-tax-testing",
    "filter": "eCommerce",
    "tag": "Checkout QA",
    "title": "How to Test Sales Tax in Your eCommerce Checkout",
    "description": "Test checkout sales tax with an evidence-based matrix for destinations, products, discounts, exemptions, refunds, and order exports.",
    "publishedOn": "2026-09-06",
    "time": "6 min read"
  },
  {
    "slug": "sales-tax-recordkeeping-guide",
    "filter": "United States",
    "tag": "Recordkeeping",
    "title": "Sales Tax Recordkeeping: What to Keep and How to Organize It",
    "description": "Build a sales tax recordkeeping system covering orders, exemptions, marketplace reports, returns, retention rules, and usable exports.",
    "publishedOn": "2026-09-06",
    "time": "6 min read"
  },
  {
    "slug": "how-to-file-sales-tax-returns",
    "filter": "United States",
    "tag": "Filing",
    "title": "How to File US Sales Tax Returns: Complete 2026 Guide",
    "description": "Prepare a US sales tax return from gross sales to payment: reconcile channels, map deductions, handle zero returns, and retain filing evidence.",
    "publishedOn": "2026-08-08",
    "time": "4 min read"
  },
  {
    "slug": "us-sales-tax-product-taxability",
    "filter": "United States",
    "tag": "Taxability",
    "title": "US Product Taxability Guide: Goods, SaaS & Services (2026)",
    "description": "Classify goods, software, services and bundles for US sales tax using product facts, state definitions, exemption evidence and tested SKU mappings.",
    "publishedOn": "2026-08-08",
    "time": "4 min read"
  },
  {
    "slug": "business-use-tax-guide",
    "filter": "United States",
    "tag": "Use Tax",
    "title": "Business Use Tax Guide: Purchases, Accruals & Audits (2026)",
    "description": "Find untaxed business purchases, assess use tax, review inventory withdrawals and reconcile accruals without duplicating tax already paid.",
    "publishedOn": "2026-08-08",
    "time": "5 min read"
  },
  {
    "slug": "eu-vat-digital-services-guide",
    "filter": "Europe",
    "tag": "Digital Services",
    "title": "EU VAT on Digital Services: B2C, B2B & OSS (2026)",
    "description": "Determine EU digital-services VAT treatment through service classification, B2B status, customer location evidence and the correct OSS reporting scheme.",
    "publishedOn": "2026-08-08",
    "time": "4 min read"
  },
  {
    "slug": "global-vat-gst-registration",
    "filter": "eCommerce",
    "tag": "Global Compliance",
    "title": "Global VAT & GST Registration Guide for eCommerce (2026)",
    "description": "Evaluate international VAT and GST registrations by seller establishment, inventory, customer status, turnover tests and marketplace responsibility.",
    "publishedOn": "2026-08-08",
    "time": "4 min read"
  },
  {
    "slug": "illinois-sales-tax-guide",
    "filter": "United States",
    "tag": "Illinois",
    "title": "Illinois Sales Tax Guide for Remote Sellers (2026)",
    "description": "A practical Illinois sales tax guide covering the 2026 remote-seller threshold, destination-based ROT, local grocery tax, marketplaces, registration, and filing.",
    "publishedOn": "2026-08-28",
    "time": "6 min read"
  },
  {
    "slug": "washington-sales-tax-guide",
    "filter": "United States",
    "tag": "Washington",
    "title": "Washington Sales Tax & B&O Guide for Remote Sellers (2026)",
    "description": "A practical Washington guide to the $100,000 threshold, destination sales tax, B&O tax, marketplace deductions, reseller permits, and excise returns.",
    "publishedOn": "2026-08-28",
    "time": "6 min read"
  },
  {
    "slug": "colorado-sales-tax-guide",
    "filter": "United States",
    "tag": "Colorado",
    "title": "Colorado Sales Tax Guide for Remote Sellers (2026)",
    "description": "A practical Colorado sales tax guide covering economic nexus, destination sourcing, state-administered and home-rule jurisdictions, SUTS, marketplaces, and filing.",
    "publishedOn": "2026-08-28",
    "time": "6 min read"
  },
  {
    "slug": "pennsylvania-sales-tax-guide",
    "filter": "United States",
    "tag": "Pennsylvania",
    "title": "Pennsylvania Sales Tax Guide for Online Sellers (2026)",
    "description": "A practical Pennsylvania guide covering the $100,000 online-seller threshold, taxable sales, marketplace channels, local tax, licensing, and returns.",
    "publishedOn": "2026-08-28",
    "time": "6 min read"
  },
  {
    "slug": "uk-vat-ecommerce-guide",
    "filter": "Europe",
    "tag": "United Kingdom",
    "title": "UK VAT for eCommerce & Overseas Sellers (2026)",
    "description": "A practical UK VAT guide covering overseas sellers, online marketplaces, £135 consignments, imports, customer evidence, returns, and audit controls.",
    "publishedOn": "2026-08-08",
    "time": "4 min read"
  },
  {
    "slug": "new-zealand-gst-overseas-sellers",
    "filter": "Asia-Pacific",
    "tag": "New Zealand",
    "title": "New Zealand GST Guide for Overseas Sellers (2026)",
    "description": "Understand New Zealand’s 15% GST for remote services, low-value imported goods, marketplaces, customer evidence, registration, returns, and records.",
    "publishedOn": "2026-08-08",
    "time": "4 min read"
  },
  {
    "slug": "singapore-gst-overseas-vendor",
    "filter": "Asia-Pacific",
    "tag": "Singapore",
    "title": "Singapore GST Guide for Overseas Vendors (2026)",
    "description": "A practical guide to Singapore’s Overseas Vendor Registration regime, remote services, low-value goods, platforms, customer evidence, filing, and controls.",
    "publishedOn": "2026-08-08",
    "time": "5 min read"
  },
  {
    "slug": "japan-consumption-tax-digital-services",
    "filter": "Asia-Pacific",
    "tag": "Japan",
    "title": "Japan Consumption Tax for Digital Services (2026)",
    "description": "Understand Japan consumption tax for cross-border digital services, B2C and B2B classification, 2025 platform taxation, invoices, registration, and records.",
    "publishedOn": "2026-08-08",
    "time": "4 min read"
  },
  {
    "slug": "india-gst-ecommerce-guide",
    "filter": "Asia-Pacific",
    "tag": "India",
    "title": "India GST for eCommerce & Digital Sellers (2026)",
    "description": "A practical India GST guide covering registration, place of supply, e-commerce operators, TCS, OIDAR, invoicing, returns, and reconciliation.",
    "publishedOn": "2026-08-08",
    "time": "4 min read"
  },
  {
    "slug": "clothing-apparel-sales-tax-guide",
    "filter": "United States",
    "tag": "Apparel",
    "title": "Sales Tax on Clothing & Apparel: 2026 Seller Guide",
    "description": "A practical state-by-state framework for clothing, footwear, accessories, price thresholds, sales tax holidays, rentals, alterations, shipping, and returns.",
    "publishedOn": "2026-08-16",
    "time": "7 min read"
  },
  {
    "slug": "food-grocery-sales-tax-guide",
    "filter": "United States",
    "tag": "Food & Grocery",
    "title": "Sales Tax on Food & Groceries: 2026 Seller Guide",
    "description": "A practical guide to grocery exemptions, prepared food, beverages, supplements, restaurants, delivery, bundles, marketplaces, and product-level tax controls.",
    "publishedOn": "2026-08-16",
    "time": "7 min read"
  },
  {
    "slug": "california-sales-tax-guide",
    "filter": "United States",
    "tag": "California",
    "title": "California Sales Tax Guide for Businesses (2026)",
    "description": "A practical California sales tax guide covering the 7.25% statewide base rate, district taxes, economic nexus, marketplaces, registration, and filing controls.",
    "publishedOn": "2026-08-23",
    "time": "6 min read"
  },
  {
    "slug": "texas-sales-tax-guide",
    "filter": "United States",
    "tag": "Texas",
    "title": "Texas Sales Tax Guide for Businesses (2026)",
    "description": "A practical Texas sales tax guide covering the 6.25% state rate, local taxes, the $500,000 remote-seller safe harbor, marketplaces, permits, and returns.",
    "publishedOn": "2026-08-23",
    "time": "6 min read"
  },
  {
    "slug": "florida-sales-tax-guide",
    "filter": "United States",
    "tag": "Florida",
    "title": "Florida Sales Tax Guide for Businesses (2026)",
    "description": "A practical Florida sales tax guide covering the 6% state rate, county discretionary surtax, remote-sales nexus, marketplaces, registration, and returns.",
    "publishedOn": "2026-08-23",
    "time": "6 min read"
  },
  {
    "slug": "new-york-sales-tax-guide",
    "filter": "United States",
    "tag": "New York",
    "title": "New York Sales Tax Guide for Businesses (2026)",
    "description": "A practical New York sales tax guide covering the 4% state rate, local destination rates, remote-seller nexus, marketplaces, clothing, and filing.",
    "publishedOn": "2026-08-23",
    "time": "6 min read"
  }
] as const
